<template>
  <b-card>
    <title-name />
  </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import TitleName from '@/views/Admin/Defines/Supplier_types/elements/Title.vue'

export default {
  name: 'CustomerTypeForm',
  components: {
    BCard,
    TitleName,
  },
}
</script>
